export const AddAccount = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z"
      fill="#1D1D1D"
    />
    <path
      d="M1.34748 20.4449C0.772837 19.5866 0.359907 18.6109 0.152272 17.5613L0.642766 17.4643C0.549158 16.9911 0.5 16.5015 0.5 16V14H0V10H0.5V8C0.5 7.49847 0.549158 7.00892 0.642766 6.53574L0.152272 6.4387C0.359906 5.38915 0.772837 4.41341 1.34748 3.55508L1.76296 3.83324C2.31067 3.01513 3.01513 2.31067 3.83323 1.76296L3.55507 1.34748C4.41341 0.772837 5.38915 0.359906 6.4387 0.152272L6.53574 0.642766C7.00892 0.549158 7.49847 0.5 8 0.5H10V0H14V0.5H16C16.5015 0.5 16.9911 0.549158 17.4643 0.642766L17.5613 0.152272C18.6109 0.359906 19.5866 0.772837 20.4449 1.34748L20.1668 1.76296C20.9849 2.31067 21.6893 3.01513 22.237 3.83323L22.6525 3.55507C23.2272 4.41341 23.6401 5.38915 23.8477 6.4387L23.3572 6.53574C23.4508 7.00892 23.5 7.49847 23.5 8V10H24V14H23.5V16C23.5 16.5015 23.4508 16.9911 23.3572 17.4643L23.8477 17.5613C23.6401 18.6109 23.2272 19.5866 22.6525 20.4449L22.237 20.1668C21.6893 20.9849 20.9849 21.6893 20.1668 22.237L20.4449 22.6525C19.5866 23.2272 18.6109 23.6401 17.5613 23.8477L17.4643 23.3572C16.9911 23.4508 16.5015 23.5 16 23.5H14V24H10V23.5H8C7.49847 23.5 7.00892 23.4508 6.53574 23.3572L6.4387 23.8477C5.38915 23.6401 4.41341 23.2272 3.55508 22.6525L3.83324 22.237C3.01513 21.6893 2.31067 20.9849 1.76296 20.1668L1.34748 20.4449Z"
      stroke="white"
      strokeOpacity="0.12"
      strokeDasharray="4 4"
    />
    <path
      d="M12 8.5V12M12 12V15.5M12 12H8.5M12 12H15.5"
      stroke="white"
      strokeOpacity="0.26"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default AddAccount
